module.exports = __webpack_public_path__ + "static/media/smart-letter-logo.5b5f75d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smart-letter-logo.svg
// module id = 521
// module chunks = 1